// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","zRed":"rgb(237, 85, 100)","primary":"#492172","accent":"#BFD730","title1":"_3HY_","title2":"_1mMn","colRight":"_3scc","vs":"VJT3","item":"_3fuh"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/CompareList/CompareList.scss
// module id = hp3r
// module chunks = 0